import { render } from "./ApplicationSection.vue?vue&type=template&id=80b9e5aa"
import script from "./ApplicationSection.vue?vue&type=script&lang=js"
export * from "./ApplicationSection.vue?vue&type=script&lang=js"

import "./ApplicationSection.vue?vue&type=style&index=0&id=80b9e5aa&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__